// Tiny pub/sub. Used as the cross-module event bus on the AppContext so a
// module never has to import another module's UI directly — it just emits.

export function createEventBus() {
    const handlers = new Map();
    return {
        on(event, handler) {
            if (!handlers.has(event)) handlers.set(event, new Set());
            handlers.get(event).add(handler);
            return () => handlers.get(event).delete(handler);
        },
        off(event, handler) {
            handlers.get(event)?.delete(handler);
        },
        emit(event, payload) {
            const set = handlers.get(event);
            if (!set) return;
            for (const h of set) {
                try { h(payload); } catch (e) { console.error(`bus[${event}]`, e); }
            }
        },
    };
}
